import { createContext, useEffect, useState } from 'react';

const ServerConfigContext = createContext(null);

function ServerConfigProvider({ children }) {
    const [config, setConfig] = useState(null);

    useEffect(() => {
        const load = async () => {
            try {
                const resp = await fetch(`${process.env.REACT_APP_WEB_API_B2C}/api/config`);
                if (resp.ok) setConfig(await resp.json());
            } catch (_) {}
        };
        load();
    }, []);

    return (
        <ServerConfigContext.Provider value={config}>
            {children}
        </ServerConfigContext.Provider>
    );
}

export { ServerConfigContext, ServerConfigProvider };
